var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"component",staticClass:"bean-button-fixed-bottom",style:([_vm.style])},[_c('div',{staticClass:"fixed-footer",style:([_vm.style, { background: _vm.bgColor, zIndex: _vm.zIndex }])},[_c('div',{staticClass:"content",class:[_vm.componentClass]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }